import { render, staticRenderFns } from "./UpdateVipTimeForm.vue?vue&type=template&id=0bfccbfc&scoped=true"
import script from "./UpdateVipTimeForm.vue?vue&type=script&lang=js"
export * from "./UpdateVipTimeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfccbfc",
  null
  
)

export default component.exports